var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import QRCode from 'qrcode.react';
import { Card } from '@material-ui/core';
var Qrcode = /** @class */ (function (_super) {
    __extends(Qrcode, _super);
    function Qrcode(props) {
        var _this = _super.call(this, props) || this;
        _this.downloadRef = '';
        _this.mount = React.createRef();
        _this.Download = function () {
            var canvas = document.querySelector('.HpQrcode > canvas');
            _this.downloadRef.href = canvas.toDataURL();
            _this.downloadRef.download = 'Designer Code.png';
        };
        _this.state = {
            open: _this.props.open
        };
        return _this;
        // this.Download = this.Download.bind(this)
    }
    Qrcode.prototype.componentWillReceiveProps = function (nextProps) {
        if (!nextProps.open) {
            this.setState({ open: this.props.open });
        }
    };
    Qrcode.prototype.render = function () {
        var _this = this;
        if (this.props.open) {
            return (React.createElement("div", { style: { minWidth: '250px', width: '25%', margin: 'auto' } },
                React.createElement(Card, { elevation: 5 },
                    React.createElement("div", { className: 'HpQrcode', ref: this.mount, style: { margin: '7%' } },
                        React.createElement(QRCode, { value: this.props.userPage, size: 200, bgColor: '#d0ac74', fgColor: '#33383b' })),
                    React.createElement("a", { onClick: this.Download, ref: function (ref) { return _this.downloadRef = ref; } }, " Download "))));
        }
        else {
            return (React.createElement("div", null));
        }
    };
    return Qrcode;
}(Component));
export { Qrcode };
export default Qrcode;



//////////////////
// WEBPACK FOOTER
// ./src/components/QRcode/qrcode.tsx
// module id = 1292
// module chunks = 0 1 2 3 4 5 6 7